import { useState } from "react";

export default (): any => {
  const [sidebar, setSidebar] = useState(false);

  const toggleSidebar = () => {
    if (sidebar) {
      setSidebar(false);
    } else {
      setSidebar(true);
    }
  };

  return [sidebar, toggleSidebar];
};
